import type { FC, ReactNode } from 'react'
import type { GetStaticProps } from 'next'
import type { MenuCategory, MenuItem } from '@/types'

import { getMenu } from '@/lib/menu'
import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { OrderBuilder } from '@/components/order/order-builder'

interface OrderPageProps {
    categories: Array<MenuCategory>
    items: Array<MenuItem>
}

const OrderPage: FC<Partial<OrderPageProps>> = ({ categories = [], items = [] }): ReactNode => {
    return (
        <Layout>
            <Seo
                title='پیش‌سفارش'
                description='نان، شیرینی و کیک را از La Douceur پیش‌سفارش دهید و در زمانی که برایتان مناسب است، حضوری تحویل بگیرید. پرداخت هنگام تحویل.'
            />

            <OrderBuilder categories={categories} items={items} />
        </Layout>
    )
}

export const getStaticProps: GetStaticProps<OrderPageProps> = async () => {
    try {
        const { categories, items } = await getMenu()
        const orderable = items.filter(item => item.orderable)
        const used = new Set(orderable.map(item => item.categorySlug))

        return {
            props: { categories: categories.filter(category => used.has(category.slug)), items: orderable },
            revalidate: 30
        }
    }
    catch (error) {
        console.error('The order page could not load the menu:', error instanceof Error ? error.message : error)

        return { props: { categories: [], items: [] }, revalidate: 10 }
    }
}

export default OrderPage
